import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import { Field } from 'redux-form';
import InputGroup from '../InputGroup';
import DropDownSelect from '../DropDownSelect';

import { validateStep2 } from './validations';
import { requiredFormElements } from './representatives';

import Button from '../../components/Button';
import TwoGroup from '../../components/TwoGroup';

import GetUpdatesCheckbox from '../Widget/GetUpdatesCheckbox';
import LegalInfo from '../Widget/LegalInfo';

import { LoadingSpinner } from '../../components/LoadingSpinner';

import { copyFor, capitalization } from '../../copy/copy';
import { isPortrait } from '../../utils/size';

import { getCachedFullName } from '../../utils/formCaching/helpers';

const DetailsFormContainer = styled.form`
    flex: 1;
    padding: 0;
    display: flex;
    flex-direction: column;
`;

const Row = styled.div`
    margin: 0 -0.5em 12px -0.5em;
    transition: opacity 0.6s;

    overflow: hidden;
    max-height: 80%;
    overflow-y: scroll;

    ${() =>
        !isPortrait() &&
        `
            &::-webkit-scrollbar {
                width: 4px;
                border-radius: 2px;
            }

            &::-webkit-scrollbar-thumb {
                border-radius: 2px;
                background: #ff245e;
            }`};

    .label-response {
        @media (min-width: 30em) {
            position: absolute;
            width: 100%;
            bottom: 142px;
            transition: bottom 0.6s;
        }
    }

    &.focused {
        opacity: 0;

        &.row-wrapper-3 {
            opacity: 1;

            .label-response {
                bottom: calc(100% - 16px);
            }

            textarea {
                height: 200px;
            }
        }
    }
`;

const HalfRow = styled.div`
    width: 50%;
    padding: 0 0.5em;
    float: left;
    margin-bottom: 10px;
    position: relative;

    @media (min-width: 30em) {
        &:nth-child(4),
        &:nth-child(5),
        &:nth-child(6) {
            ${props => (props.allVisible ? 'width: calc(100% / 3)' : 'width: 50%')};
        }
    }

    @media (max-width: 30em) {
        width: 50%;
    }
`;

const ThirdRow = styled.div`
    padding: 0 0.5em;
    float: left;
    margin-bottom: 10px;
    position: relative;
    width: 40%;

    @media (max-width: 30em) {
        width: 50%;
    }
`;

const QuarterRow = styled.div`
    width: 20%;
    padding: 0 0.5em;
    float: left;
    margin-bottom: 10px;
    position: relative;

    @media (max-width: 30em) {
        width: 50%;
    }
`;

const ButtonGroup = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    position: absolute;
    right: 0;
    bottom: 10px;
    width: 70%;

    @media (max-width: 30em) {
        width: 100%;
    }

    > div {
        position: relative;
    }

    button {
        &.submitButton {
            ${props => (props.isSubmitting ? `text-indent: -99999px;` : '')};
            margin-left: 0.5em;

            @media (max-width: 30em) {
                width: calc(50% - 0.5em);
            }
        }

        &.middleButton {
            @media (max-width: 30em) {
                width: calc(50% - 0.5em);
                margin-right: 0.5em;
            }
        }

        &:focus {
            outline: none;
        }

        + div {
            position: absolute;
            display: none;
            top: 7px;
            right: 24%;
            margin-right: -16px;
            width: 32px !important;
            height: 32px !important;
            ${props => (props.isSubmitting ? `display: block` : '')};
        }
    }
`;

const LegalInfoWrapper = styled.div`
    position: absolute;
    left: 0;
    bottom: 10px;
    width: 30%;
    padding-right: 10px;

    @media (max-width: 30em) {
        width: 100%;
        bottom: 70px;
        padding-right: 0;
    }
`;

const FormGroupWrapper = styled.div`
    @media (max-width: 30em) {
        flex: 1;
        display: flex;
        flex-direction: row;
        margin: 0 -0.5em;

        > div {
            flex: 1;
            display: flex;
            flex-direction: column;
            margin: 0 0.5em;
        }
    }
`;

const DetailsFormMultiRepStep2 = props => (
    <DetailsFormContainer onSubmit={props.handleSubmit} autocomplete="on">
        <Row>
            {props.requiredFormElements
                .filter(function(a) {
                    return a.name === 'NamePrefix';
                })
                .map(a => (
                    <QuarterRow key={a.index}>
                        <Field
                            name="prefix"
                            component={a.options.length > 0 ? DropDownSelect : InputGroup}
                            options={a.options}
                            defaultOption={a.defaultOption}
                            type="text"
                            label={a.placeholder}
                            placeholder={a.placeholder}
                        />
                    </QuarterRow>
                ))}
            <ThirdRow>
                <Field
                    name="fullName"
                    component={InputGroup}
                    type="text"
                    label={copyFor('formFields', 'fullName', 'email', capitalization.all)}
                    placeholder={copyFor('placeholders', 'fullName', 'email')}
                />
            </ThirdRow>
            <ThirdRow>
                <Field
                    name="email"
                    component={InputGroup}
                    type="email"
                    label={copyFor(
                        'formFields',
                        'emailAddress',
                        'email',
                        capitalization.all
                    )}
                    placeholder={copyFor('placeholders', 'emailAddress', 'email')}
                />
            </ThirdRow>
            {props.requiredFormElements
                .filter(a => a.name !== 'NamePrefix' && a.name !== 'Topic')
                .sort((a, b) => a.index - b.index)
                .map((a, index) => (
                    <HalfRow
                        key={a.index}
                        allVisible={props.requiredFormElements.length === 7}
                    >
                        <Field
                            name={a.name}
                            key={index}
                            component={a.options.length > 0 ? DropDownSelect : InputGroup}
                            options={a.options}
                            defaultOption={a.defaultOption}
                            type="text"
                            label={a.placeholder}
                            placeholder={a.placeholder}
                        />
                    </HalfRow>
                ))}
        </Row>
        <LegalInfoWrapper>
            <FormGroupWrapper>
                <GetUpdatesCheckbox />
                <LegalInfo align="mobile-right" />
            </FormGroupWrapper>
        </LegalInfoWrapper>
        <ButtonGroup isSubmitting={props.isSubmitting}>
            <TwoGroup>
                <Button
                    label={copyFor('buttons', 'back', 'email', capitalization.eachWord)}
                    onClick={props.onBackFromStep2}
                    className="middleButton"
                />
                <Button
                    primary={true}
                    label={copyFor('buttons', 'send', 'email', capitalization.eachWord)}
                    type="submit"
                    className="submitButton"
                    disabled={props.invalid}
                />
                <LoadingSpinner />
            </TwoGroup>
        </ButtonGroup>
    </DetailsFormContainer>
);

DetailsFormMultiRepStep2.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
    invalid: PropTypes.bool.isRequired,
    requiredFormElements: PropTypes.array.isRequired,
    onBackFromStep2: PropTypes.func.isRequired
};

export default compose(
    connect(state => {
        return {
            requiredFormElements: requiredFormElements(state),
            initialValues: {
                prefix: state.cachedFormData.prefix || '',
                fullName: getCachedFullName(state),
                email: state.cachedFormData.email || '',
                getUpdates: true
            },
            localRepFullName:
                state.localRep.localRepData.representative !== undefined
                    ? state.localRep.localRepData.representative[0].fullName
                    : ''
        };
    }),
    reduxForm({
        form: 'emailDetailsFormMultiRepStep2',
        validate: validateStep2,
        destroyOnUnmount: false
    })
)(DetailsFormMultiRepStep2);



// WEBPACK FOOTER //
// ./src/components/Email/DetailsFormMultiRepStep2.jsx